import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function DescSort(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="10"
        height="13"
        viewBox="0 0 10 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.98522 3.67194C8.41777 3.67194 8.80772 3.93994 8.97325 4.35098C9.13878 4.76203 9.04728 5.23516 8.74143 5.54975L5.53312 8.84975C5.11547 9.27933 4.43834 9.27933 4.0207 8.84975L0.812394 5.54975C0.506536 5.23516 0.415041 4.76203 0.580569 4.35098C0.746098 3.93994 1.13605 3.67194 1.5686 3.67194L7.98522 3.67194Z"
          fill="#173E96"
        />
      </svg>
    </SvgIcon>
  );
}
